export const LEAVE_HOME = 'LEAVE_HOME';
export const GOTO_HOME = 'GOTO_HOME';
export const SCROLL_TO = 'SCROLL_TO';
export const SHOW_LOADER = 'SHOW_LOADER';
export const ABOUT_OFFSET = 'ABOUT-OFFSET';
export const SERVICES_OFFSET = 'SERVICES-OFFSET';
export const PORTFOLIO_OFFSET = 'PORTFOLIO-OFFSET';
